import { render, staticRenderFns } from "./ButtonWithLoader.vue?vue&type=template&id=6395d213&scoped=true&"
import script from "./ButtonWithLoader.vue?vue&type=script&lang=js&"
export * from "./ButtonWithLoader.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWithLoader.vue?vue&type=style&index=0&id=6395d213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6395d213",
  null
  
)

export default component.exports